import { FEATURE_FLAGS } from '@vizit/constants';
import { useFeatureFlag } from './use-feature-flag';

/**
 * SPM-3405: returns whether the favourites surfaces should be shown.
 *
 * Centralizes the `show-favorites` LaunchDarkly flag so the heart toggle on
 * asset tiles and the favorites-only filters — which live in three separate
 * packages — share one source of truth. Defaults to `false`: favourites stay
 * hidden until the flag is explicitly enabled. Stored favourites are never
 * affected either way, so they reappear intact when it is turned on.
 */
function useShowFavorites(): boolean {
  return useFeatureFlag(FEATURE_FLAGS.SHOW_FAVORITES, false);
}

export { useShowFavorites };
